import { render } from "./index.vue?vue&type=template&id=0992c958"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/BaseProductFreeze/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0992c958"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0992c958', __exports__)) {
    api.reload('0992c958', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=0992c958", () => {
    api.rerender('0992c958', render)
  })

}


export default __exports__